import React from 'react';
import Hero from './sections/Hero';
import MarketProblem from './sections/MarketProblem';
import WhatWeDo from './sections/WhatWeDo';
import Capabilities from './sections/Capabilities';
import FeaturedWork from './sections/FeaturedWork';
import Subscriptions from './sections/Subscriptions';
import Process from './sections/Process';
import InsightsPreview from './sections/InsightsPreview';
import FinalCTA from './sections/FinalCTA';

export default function Home() {
  return (
    <div className="bg-[#030509] text-white">
      <Hero />
      <MarketProblem />
      <WhatWeDo />
      <Capabilities />
      <FeaturedWork />
      <Subscriptions />
      <Process />
      <InsightsPreview />
      <FinalCTA />
    </div>
  );
}